import moment from 'moment';
import {formatDate, toPhilMoment} from '@/utils/dates';
import {doctorNameWithTitle} from '@/filters';
import {
  AppointmentStatusNewRequest,
  AppointmentStatusWithToken, CancelStatuses,
} from '@/constants';
import {ONDEMAND_STATUSES} from '@/reference/ondemand';

export default {
  filters: {
    doctorNameWithTitle,
  },
  computed: {
    appointmentStatusIcon() {
      switch (this.appointment.status) {
        case AppointmentStatusWithToken.Queued:
        case AppointmentStatusWithToken.Serving:
        case ONDEMAND_STATUSES.PAYMENT:
        case ONDEMAND_STATUSES.ACCEPT:
          return ['ns-icon-calendar-confirmed', 'ns-appointment__icon-confirmed'];
        case AppointmentStatusWithToken.Complete:
          return ['ns-icon-check-filled', 'ns-appointment__icon-completed'];
        case AppointmentStatusWithToken.Skip:
          return ['ns-icon-triangle-warning', 'ns-appointment__icon-skipped'];
        case AppointmentStatusWithToken.Cancel:
          return ['ns-icon-calendar-cancelled', 'ns-appointment__icon-cancelled'];
        case AppointmentStatusWithToken.NoShow:
        case AppointmentStatusNewRequest.autocancelled:
        case AppointmentStatusNewRequest.cancelled:
        case AppointmentStatusNewRequest.reject:
        case AppointmentStatusWithToken.Denied:
        case ONDEMAND_STATUSES.CANCELLED:
        case ONDEMAND_STATUSES.AUTOCANCELLED:
        case ONDEMAND_STATUSES.PAYMENT_AUTOCANCELLED:
        case ONDEMAND_STATUSES.REJECT:
          return ['ns-icon-minus-filled', 'ns-appointment__icon-denied'];
        default:
          return ['ns-icon-clock', 'ns-appointment__icon-pending'];
      }
    },
    appointmentTime() {
      return (this.hasToken && this.appointment.starttime !== null)
        ? toPhilMoment(this.appointment.starttime).format('h:mm A') //normal moment(date).format also gives localtime
        : '';
    },
    hasToken() {
      return this.appointment.accesstoken !== undefined;
    },
    formattedPatientName() {
      return this.hasToken ? this.appointment.patient.name : `${this.appointment.firstname} ${this.appointment.middlename || ''} ${this.appointment.lastname}`;
    },
    formattedAppointmentDate() {
      const momentDate = this.hasToken
        ? moment(this.appointment.date) // expects iso string
        : moment(this.appointment.date, 'MM/DD/YYYY'); // expects specific format if new request appointment
      let displayFormat = 'MMM DD YYYY, dddd';
      let dateFormat = 'MMM DD YYYY';
      let dayFormat = 'dddd';

      const time = this.appointmentTime ? `${this.appointmentTime}` : '';
      const dateString = this.hasToken
        ? `<span class="date">${formatDate(momentDate, dateFormat)}</span>, 
          ${formatDate(momentDate, dayFormat)}
          <span class="time">${time}</span>`
        : formatDate(momentDate, displayFormat);

      return dateString;
    },
    profileUrl() {
      return this.hasToken ? this.appointment.doctor.profile_url : this.appointment.profile_url;
    },
    mainSpecialty() {
      return this.hasToken ? this.appointment.doctor.mainspecialty : this.appointment.mainspecialty;
    },
    typeOfConsultClass() {
      return this.appointment.virtualconsult ? 'ns-icon-video' : 'ns-icon-location';
    },
    typeOfConsultText() {
      return this.appointment.virtualconsult ? 'Virtual Consult' : this.appointment.clinicname;
    },
  },
  methods: {
    handleTextPerStatus() {
      switch (this.appointment.status) {
        case AppointmentStatusWithToken.Queued:
          this.stringSet = this.$options.statusTextObj.Queued;
          break;
        case AppointmentStatusWithToken.Pending:
          this.stringSet = this.$options.statusTextObj.Pending;
          break;
        case AppointmentStatusWithToken.Complete:
          this.stringSet = this.$options.statusTextObj.Complete;
          break;
        case AppointmentStatusWithToken.Skip:
        case AppointmentStatusWithToken.NoShow:
          this.stringSet = this.$options.statusTextObj.Skipped;
          break;
        case CancelStatuses.autocancelled:
        case CancelStatuses.cancelled:
        case AppointmentStatusWithToken.Cancel:
          this.stringSet = this.$options.statusTextObj.Cancelled;
          break;
        case AppointmentStatusNewRequest.reject:
        case AppointmentStatusNewRequest.autocancelled:
        case AppointmentStatusNewRequest.cancelled:
        case AppointmentStatusWithToken.Denied:
          this.stringSet = this.$options.statusTextObj.Denied;
          break;
      }
    },
  },
  statusTextObj: {
    Queued: {
      title: 'Consultation Confirmed',
      subtitle: 'Your consultation request has been confirmed'
    },
    Pending: {
      title: 'Pending',
      subtitle: 'The doctor has yet to approve of your consultation request'
    },
    Complete: {
      title: 'Completed',
      subtitle: 'Your consultation has been completed'
    },
    Denied: {
      title: 'Denied',
      subtitle: 'Your consultation request was denied'
    },
    Skipped: {
      title: 'Skipped',
      subtitle: 'You skipped your consultation'
    },
    Cancelled: {
      title: 'Cancelled',
      subtitle: 'Your consultation was cancelled.'
    }
  }
}
